function isRelativePath(path: string): boolean {
	return !/^([a-z]+:)?\/\//i.test(path) && !path.startsWith('/');
}

export default isRelativePath;
